import { GAMEWIKI_MOUNT_PATH } from '@home/pages/GameWiki/constants';

export interface IGameWikiKbDetailUrlParams {
  /** 空间/租户 ID（对应 fromTenantId） */
  tenantId: string;
  /** 知识库 ID（路径段 knowledge-bases/{id}） */
  knowledgeBaseId: string;
  /** 文档 ID（query knowledge_id） */
  knowledgeId: string;
}

/**
 * 构建 GameWiki 知识库详情页 URL
 * 父路由：/gamewiki/space/{tenantId}/kb/{knowledgeBaseId}?knowledge_id={knowledgeId}
 * 子应用：/kb/platform/knowledge-bases/{knowledgeBaseId}?knowledge_id=...&fromTenantId=...
 */
export const buildGameWikiKbDetailUrl = ({
  tenantId,
  knowledgeBaseId,
  knowledgeId,
}: IGameWikiKbDetailUrlParams): string => {
  const base = `${GAMEWIKI_MOUNT_PATH}/space/${tenantId}/kb/${knowledgeBaseId}`;
  const params = new URLSearchParams({ knowledge_id: knowledgeId });
  return `${base}?${params.toString()}`;
};
